module.exports = __webpack_public_path__ + "img/bz@2x copy.068b92af.png";